import {api} from './api';
import {
    Announcement,
    AnnouncementValidationReq,
    AnnouncementValidationResult,
    ApiResponse,
    PageResponse
} from '../types/announcement';

export const announcementService = {
    /**
     * 分页获取公告列表
     */
    getAnnouncementList: async (page: number = 0, size: number = 20): Promise<PageResponse<Announcement>> => {
        const response = await api.get<ApiResponse<PageResponse<Announcement>>>(
            `/api/v1/system/announcements?page=${page}&size=${size}`
        );
        if (response.data.success && response.data.data) {
            return response.data.data;
        }
        return {
            content: [],
            totalElements: 0,
            totalPages: 0,
            number: 0,
            size: size
        };
    },

    /**
     * 获取当前有效的公告列表
     */
    getActiveAnnouncements: async (): Promise<Announcement[]> => {
        const response = await api.get<ApiResponse<Announcement[]>>('/api/v1/system/announcements/active');
        if (response.data.success && response.data.data) {
            return response.data.data;
        }
        return [];
    },

    /**
     * 获取公告详情
     */
    getAnnouncementDetail: async (id: number): Promise<Announcement | null> => {
        const response = await api.get<ApiResponse<Announcement>>(`/api/v1/system/announcements/${id}`);
        if (response.data.success && response.data.data) {
            return response.data.data;
        }
        return null;
    },

    /**
     * 创建公告
     */
    createAnnouncement: async (announcement: Announcement): Promise<Announcement | null> => {
        const response = await api.post<ApiResponse<Announcement>>('/api/v1/system/announcements', announcement);
        if (response.data.success && response.data.data) {
            return response.data.data;
        }
        throw new Error(response.data.message || '创建失败');
    },

    /**
     * 更新公告
     */
    updateAnnouncement: async (id: number, announcement: Announcement): Promise<Announcement | null> => {
        const response = await api.put<ApiResponse<Announcement>>(`/api/v1/system/announcements/${id}`, announcement);
        if (response.data.success && response.data.data) {
            return response.data.data;
        }
        throw new Error(response.data.message || '更新失败');
    },

    /**
     * 删除公告
     */
    deleteAnnouncement: async (id: number): Promise<boolean> => {
        const response = await api.delete<ApiResponse<boolean>>(`/api/v1/system/announcements/${id}`);
        return response.data.success === true;
    },

    /**
     * 校验公告（标题重复检查 + 时间重叠检查）
     */
    validateAnnouncement: async (req: AnnouncementValidationReq): Promise<AnnouncementValidationResult> => {
        const response = await api.post<ApiResponse<AnnouncementValidationResult>>('/api/v1/system/announcements/validate', req);
        if (response.data.success && response.data.data) {
            return response.data.data;
        }
        throw new Error(response.data.message || '校验失败');
    }
};
